// extracted by mini-css-extract-plugin
module.exports = {"container":"nGyEC5nC7E77GMpRVD8pt","groupsList":"_5S568MUD8BK4h4Stafsp2"};